import React from "react";
import { Target } from "lucide-react";
import RevealOnScroll from "./RevealOnScroll";

const PositioningSection = () => {
  return (
    <section className="section-spacing bg-gradient-to-b from-white to-[#f5f5f5]">
      <div className="container-custom">
        <div className="max-w-5xl mx-auto">
          <RevealOnScroll variant="scale">
          <div className="glass-dark p-12 md:p-16 rounded-3xl relative overflow-hidden">
            {/* Decorative element */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#4a9da8]/10 rounded-full blur-3xl"></div>
            
            <div className="relative z-10">
              <div className="flex items-center gap-4 mb-8">
                <div className="w-14 h-14 bg-gradient-to-br from-[#2c4a52] to-[#4a9da8] rounded-xl flex items-center justify-center">
                  <Target className="w-7 h-7 text-white" />
                </div>
                <div className="inline-block px-4 py-2 bg-[#4a9da8]/10 text-[#4a9da8] text-sm font-semibold rounded-full">
                  Unsere Überzeugung
                </div>
              </div>
              
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight">
                Digitale Vermarktung ist nur dann sinnvoll, wenn sie 
                <span className="text-[#4a9da8]"> steuerbar und verständlich</span> bleibt.
              </h2>
              
              <p className="text-xl text-white/70 leading-relaxed">
                Deshalb arbeiten wir strukturiert, datenbasiert und mit klar definierten Zielen – statt kurzfristigen Trends zu folgen.
              </p>
            </div>
          </div>
          </RevealOnScroll>
        </div>
      </div>
    </section>
  );
};

export default PositioningSection;
